export default __webpack_public_path__ + "static/pawlicka-dd35ce0bd7ab3f20f1c2ef12f91d1c2b.jpg";